var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fun-item"},[_c('div',{staticClass:"fun-item-class"},[_vm._v(_vm._s(_vm.clazz.name))]),_c('div',{staticClass:"fun-item-list"},[_vm._l((_vm.funList),function(fun,index){return [_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.showFun(index)}}},[_vm._v(_vm._s(fun.title))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }